import { handleBilanSelectById, handleAnalyseSelectById, commentMustNotBeCompleted } from "../utilities/utils";
import { useState, useEffect } from 'react';
import TextButton from "./TextButton";
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { Download } from "lucide-react";


export default function AnamneseWindow({ display, id, type, closeWindow, setAnalyses, analyses, bilans, setBilans }) {

    //type: analyse, bilan, falseBilan

    const [comments, setComments] = useState([])

    useEffect(() => {

        if (display) {
            let analyseTmp = null
            if (type === "analyse") {
                for (const category of analyses) {
                    analyseTmp = category.analyses.find((analyse) => analyse.id === id)
                    if (analyseTmp) break;
                }
            } else if (type === "falseBilan") {
                for (const category of analyses) {
                    analyseTmp = category.bilans.find((bilan) => bilan.id === id)
                    if (analyseTmp) break;
                }
            } else if (type === "bilan") {
                analyseTmp = bilans.find((bilan) => bilan.id === id)
            }
            const commentsTmp = analyseTmp.comments.filter((comment) => !commentMustNotBeCompleted(comment.id, analyses, bilans))
            if (commentsTmp.length === 0) {
                setActiveTab(1)
                closeWindow()
            }
            const sortedComments = [...commentsTmp].sort((a, b) => a.title.localeCompare(b.title));
            setComments(sortedComments)

        } else {
            setComments([])
        }

    }, [id, type, analyses, bilans, display, closeWindow])

    const [activeTab, setActiveTab] = useState(1)

    const injectComments = () => {
        if (type === "analyse") {
            const categoriesTmp = analyses.map((category) => {
                return {
                    ...category,
                    analyses: category.analyses.map((analyse) => {
                        if (analyse.id === id) {
                            return {
                                ...analyse,
                                comments: comments
                            }
                        } else return analyse
                    })
                }
            })
            setAnalyses(categoriesTmp)
        } else if(type === "falseBilan"){
            const categoriesTmp = analyses.map((category) => {
                return {
                    ...category,
                    bilans: category.bilans.map((bilan) => {
                        if (bilan.id === id) {
                            return {
                                ...bilan,
                                comments: comments
                            }
                        } else return bilan
                    })
                }
            })
            setAnalyses(categoriesTmp)
        } else if (type === "bilan") {
            const bilansTmp = bilans.map((bilan) => {
                if (bilan.id === id) {
                    return {
                        ...bilan,
                        comments: comments
                    }
                } return bilan
            })
            setBilans(bilansTmp)
        }
    }

    const handleSubmit = () => {
        // On vérifie tous les onglets (comment) => on renvoie au premier comment non complet et sinon on ferme
        if (tabIsComplete()) {
            injectComments()
            closeWindow()
            setActiveTab(1)
        } else {
            window.alert("Tous les champs sont obligatoires")
        }
    }

    const handleNoSubmit = () => {
        if (type === "analyse") handleAnalyseSelectById(id, false, setAnalyses, analyses);
        else if (type === "falseBilan") handleAnalyseSelectById(id, true, setAnalyses, analyses);
        else if (type === "bilan") handleBilanSelectById(id, bilans, setBilans, setAnalyses)
        setActiveTab(1)
        closeWindow();
    }


    const handleChangeComment = (comment) => {
        const commentsTmp = comments.map((com) => {
            if (com.id === comment.id) {
                return comment
            } else return com
        })

        setComments(commentsTmp)
    }

    const handleNext = () => {
        if (tabIsComplete()) setActiveTab(activeTab + 1)
        else window.alert("Tous les champs doivent être complétés pour poursuivre");
    }

    const tabIsComplete = () => {
        let verif = true
        comments[activeTab - 1].entries.forEach((entry) => {
            if (entry.type !== "FILE_DOWNLOAD") {
                if (!entry?.value) {
                    verif = false
                }
            }
        })
        return verif
    }

    return (
        <div className="popup-bg" style={display ? {} : { display: "none" }}>
            <div className="popup-window bg-white p-10 flex flex-col max-w-96 max-h-[80vh] overflow-y-auto">
                {comments.length > 0 && <CommentWindow comment={comments[activeTab - 1]} setComment={handleChangeComment} />}
                <div className="flex flex-col items-center gap-3 pt-3">
                    {activeTab < comments.length && <TextButton className="w-60" text="Suivant >" onClick={handleNext} />}
                    {activeTab > comments.length && <TextButton className="w-60" text="< Précédent" onClick={() => setActiveTab(activeTab - 1)} />}
                    {activeTab === comments.length && <TextButton className="w-60" text="Valider" onClick={handleSubmit} />}
                    <TextButton className="w-60" red={true} text="Supprimer l'analyse" onClick={handleNoSubmit} />
                </div>
            </div>
        </div>
    )
}

function CommentWindow({ comment, setComment }) {

    const handleChange = (e) => {
        const { name, value } = e.target
        const entriesTmp = comment.entries.map((entry) => {
            if (entry.label === name) {
                return {
                    ...entry,
                    value: value
                }
            } else return entry
        })
        setComment({
            ...comment,
            entries: entriesTmp
        })
    }

    return (
        <>
            <h2 className="text-base mb-2">{comment?.title || ""}</h2>
            <p className="text-dark-green font-sm">{comment?.description ? parse(DOMPurify.sanitize(comment.description)) : ""}</p>
            <form className="flex flex-col items-center gap-3 p-3">
                {comment.entries.map((entry) => {
                    if (entry.type === "SHORT_TEXT") {
                        return <ShortText key={entry.label} entry={entry} value={entry?.value || ""} handleChange={handleChange} />
                    } else if (entry.type === "LONG_TEXT") {
                        return <LongText key={entry.label} entry={entry} value={entry?.value || ""} handleChange={handleChange} />
                    } else if (entry.type === "SELECT") {
                        return <SelectField key={entry.label} entry={entry} value={entry?.value || ""} handleChange={handleChange} />
                    } else if (entry.type === "FILE_DOWNLOAD") {
                        return <FileDownload key={entry.label} entry={entry} />
                    } else return null
                })}
            </form>
        </>
    )
}

function SelectField({ entry, value, handleChange }) {

    const Option = ({ label }) => {
        return (
            <option value={label}>{label}</option>
        )
    }

    return (
        <div className="flex flex-col">
            <label className="text-dark-green text-sm">{entry.label}</label>
            <select className="simple-input" name={entry.label} value={value} onChange={handleChange} required>
                <option value="" disabled hidden></option>
                {entry.select_choices.map((choice) => <Option key={choice.label} label={choice.label} />)}
            </select>
        </div>
    )
}
function ShortText({ entry, value, handleChange }) {

    return (
        <div className="flex flex-col">
            <label className="text-dark-green text-sm">{entry.label}</label>
            <input className="simple-input" name={entry.label} value={value} onChange={handleChange} required></input>
        </div>
    )
}
function LongText({ entry, value, handleChange }) {

    return (
        <div className="flex flex-col">
            <label className="text-dark-green text-sm">{entry.label}</label>
            <textarea className="simple-input" name={entry.label} value={value} onChange={handleChange} rows="4" cols="30" required></textarea>
        </div>
    )
}
function FileDownload({ entry }) {

    const downloadFile = () => {
        window.open(entry.file_link, "_blank");
    };

    return (
        <>
            <label className="text-dark-green text-sm">{entry.label}</label>
            <TextButton text="Télécharger" onClick={downloadFile} lucideIcon={<Download size={16} className="text-dark-green" />} />
        </>

    )
}